import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../../medias/logoAlpha.png";
import { styles, sxStyles } from "../../../theme";
import { YouTube, Instagram, Facebook, Twitter } from "@mui/icons-material";
import { cardSpaceMobile, smallSpace } from "../../../theme/styles";
const HOME = `/${process.env.REACT_APP_HOME_COACH}`
export const TikTok = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    style={{
      marginLeft: "2px",
      marginTop: "0.5px",
      border: "1px solid white",
    }}
  >
    <path
      fill="currentColor"
      d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6c0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64c0 3.33 2.76 5.7 5.69 5.7c3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48"
    />
  </svg>
);

interface Props {
  id: string;
}

export const Footer = ({ id }: Props) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();

  return (
    <>
      {isDesktop ? (
        <>
          <Grid
            id={id}
            container
            style={{
              marginTop: "80px",
              ...styles.gridContainer,
              ...styles.footer,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                fontSize: "12px",
                display: "flex",
                marginBottom: smallSpace,
                // marginTop: "100px",
                maxWidth: "140vh",
              }}
            >
              Opclub.gg isn't endorsed by Riot Games and doesn't reflect the
              views or opinions of Riot Games or anyone officially involved in
              producing <br />
              or managing Riot Games properties. Riot Games, and all associated
              properties are trademarks or registered trademarks of Riot Games,
              Inc.
            </Typography>

            {/* <div style={{ display: "flex", width: "100%", marginTop: "5vh" }}> */}
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              <Grid
                container
                item
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "right",
                  width: "100%",
                }}
              >
                <div
                  onClick={() => navigate(`${HOME}`)}
                  style={{ marginLeft: "-25px", transform: "translateY(5px)" }}
                >
                  <img src={logo} style={{ width: 230 }} alt="OP Club" />
                </div>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "1vh",
                  }}
                >
                  <YouTube style={styles.icon} />
                  <Twitter style={styles.icon} />
                  <Instagram style={styles.icon} />
                  <Facebook style={styles.icon} />
                  <TikTok />
                </Grid>
              </Grid>

              <hr
                style={{
                  border: "none", // Remove a borda padrão
                  borderTop: "1px solid #ccc", // Linha de 1px de espessura com cor cinza claro
                  margin: "20px 0", // Margem superior e inferior de 20px
                  width: "100%",
                }}
              />
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {/* <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              > */}
                <Typography component="span">
                  © 2024. OP Club. Todos os direitos reservados
                </Typography>
                <Grid style={{ display: "flex" }}>
                  <Typography
                    component="a"
                    href="/"
                    sx={sxStyles.anchor()}
                    style={{ padding: 0, marginRight: 0 }}
                  >
                    Termos & Condições
                  </Typography>
                  <Typography
                    component="a"
                    href="/"
                    sx={sxStyles.anchor()}
                    style={{ padding: 0, marginRight: 0 }}
                  >
                    Política de Privacidade
                  </Typography>
                </Grid>
                {/* </div> */}
              </Grid>
            </Grid>
            {/* </div> */}
          </Grid>
        </>
      ) : (
        <>
          <Grid
            id={id}
            container
            style={{
              // ...styles.gridContainerMobile,
              ...styles.footerMobile,
              marginTop: cardSpaceMobile,
              paddingRight: "2vh",
              paddingLeft: "2vh",
            }}
          >
            <Typography
              style={{
                fontSize: "12px",
                display: "flex",
                marginBottom: smallSpace,
                textAlign: "center",
                // marginTop: "100px",
                maxWidth: "140vh",
              }}
            >
              Opclub.gg isn't endorsed by Riot Games and doesn't reflect the
              views or opinions of Riot Games or anyone officially involved in
              producing or managing Riot Games properties. Riot Games, and all
              associated properties are trademarks or registered trademarks of
              Riot Games, Inc.
            </Typography>

            {/* <div style={{ display: "flex", width: "100%", marginTop: "5vh" }}> */}
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                textAlign: "left",
              }}
            >
              <Grid
                container
                item
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "right",
                  width: "100%",
                }}
              >
                <div
                  onClick={() => navigate(`${HOME}`)}
                  style={{ marginRight: "15px", transform: "translateY(5px)" }}
                >
                  <img src={logo} style={{ width: 180 }} alt="OP Club" />
                </div>
                <Grid
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "1vh",
                  }}
                >
                  <YouTube style={styles.icon} />
                  <Twitter style={styles.icon} />
                  <Instagram style={styles.icon} />
                  <Facebook style={styles.icon} />
                  <TikTok />
                </Grid>
              </Grid>

              <hr
                style={{
                  border: "none", // Remove a borda padrão
                  borderTop: "1px solid #ccc", // Linha de 1px de espessura com cor cinza claro
                  margin: "20px 0", // Margem superior e inferior de 20px
                  width: "100%",
                }}
              />
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  flexDirection: "column-reverse",
                }}
              >
                {/* <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              > */}
                <Typography
                  component="span"
                  style={{ fontSize: "14px", marginTop: "10px" }}
                >
                  © 2024. OP Club. Todos os direitos reservados
                </Typography>
                <Grid style={{ display: "flex" }}>
                  <Typography
                    component="a"
                    href="/"
                    sx={sxStyles.anchor()}
                    style={{ padding: 0, marginRight: 0, fontSize: "14px" }}
                  >
                    Termos & Condições
                  </Typography>
                  <Typography
                    component="a"
                    href="/"
                    sx={sxStyles.anchor()}
                    style={{ padding: 0, marginRight: 0, fontSize: "14px" }}
                  >
                    Política de Privacidade
                  </Typography>
                </Grid>
                {/* </div> */}
              </Grid>
            </Grid>
            {/* </div> */}
          </Grid>
        </>
      )}
    </>
  );
};
